import React from "react";
import { presetFor } from "@/lib/avatars";

// One avatar for the whole app (2026-10-03): the user's chosen avatar
// (preset or uploaded photo), else their Google/GitHub photo, else initials.
export function UserAvatar({ user, size = 24, className = "rounded-full" }) {
  const style = { width: size, height: size };
  const avatar = user?.avatar || "";
  const preset = presetFor(avatar);
  if (preset) {
    const Icon = preset.icon;
    return (
      <span data-testid="user-avatar" data-avatar={preset.id} className={`inline-flex flex-shrink-0 items-center justify-center text-white ${className}`}
        style={{ ...style, background: `linear-gradient(135deg, ${preset.from}, ${preset.to})` }} aria-label={preset.label}>
        <Icon style={{ width: size * 0.55, height: size * 0.55 }} />
      </span>
    );
  }
  const photo = avatar.startsWith("data:image/") ? avatar : user?.picture;
  if (photo) return <img data-testid="user-avatar" src={photo} alt="" className={`flex-shrink-0 object-cover ${className}`} style={style} />;
  return (
    <span data-testid="user-avatar" className={`inline-flex flex-shrink-0 items-center justify-center bg-gradient-to-tr from-[#A67C52] to-[#3D9970] text-white font-black ${className}`}
      style={{ ...style, fontSize: Math.max(10, size * 0.42) }}>
      {(user?.name || user?.email || "U")[0].toUpperCase()}
    </span>
  );
}
